<ng-container *ngIf="!hideForClients.includes(hubName)">
  <!-- Horizontal Layout -->
  <ng-container *ngIf="style==='iti-horizontal'">
    <div class="flex items-center justify-center">
      <div class="text-xs 2xl:text-sm text-gray-600 font-semibold mr-3 ig-powerby-text" id="powered-by-label">
        Powered by
      </div>
      <a
        href="https://iti-digital.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="ITI Digital - Opens in a new window"
        class="relative -top-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 rounded-sm">
        <img
          [src]="itiLogoUrl"
          alt="ITI Digital Logo"
          class="h-14 xl:h-16"
          width="auto"
          height="auto"
          loading="lazy">
      </a>
    </div>
  </ng-container>

  <!-- Vertical Layout -->
  <div *ngIf="style==='iti-vertical'">
    <div>
      <div class="text-xs 2xl:text-sm text-gray-600 font-semibold mb-1 ig-powerby-text pl-1" id="powered-by-vertical-label">
        Powered by
      </div>
      <a
        href="https://iti-digital.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="ITI Digital - Opens in a new window"
        class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 rounded-sm inline-block">
        <img
          [src]="itiLogoUrl"
          alt="ITI Digital Logo"
          class="h-[36px]"
          width="auto"
          height="auto"
          loading="lazy">
      </a>
    </div>
  </div>
</ng-container>
